import { useUser } from '../../contexts/UserContext';
import { useOperator } from '../../contexts/OperatorContext';
import { NavigationMenu } from './NavigationMenu';
import {
  AppBar,
  IconButton,
  makeStyles,
  useMediaQuery,
} from '@material-ui/core';
import { mdScreen } from '../../lib/constants';
import clsx from 'clsx';
import { LogoButton } from './LogoButton';
import { useState } from 'react';
import { Breadcrumbs } from './Breadcrumbs';
import { UserPreferences } from '../UserPreferences';
import { MenuDivider } from './MenuDivider';
import { Close, Menu } from '@material-ui/icons';
import { AnimationWrapper } from './AnimationWrapper';
import { AppViewMenu } from './AppViewMenu';

export const Navigation = (props: NavigationProps) => {
  const { isDarkMode, setIsDarkMode } = props;
  const isMobile = useMediaQuery(mdScreen);
  const operator = useOperator();
  const user = useUser();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState('');
  const classes = useStyles();

  const loading = user.loading || operator.loading;

  return (
    <>
      {isMobile ? (
        <AppBar className={classes.mobileResort} position="fixed">
          <AppViewMenu loading={loading} />
          <IconButton
            className={clsx(classes.icon, classes.menuIcon)}
            disableRipple
            onClick={() => {
              setMenuOpen(!menuOpen);
            }}
          >
            {menuOpen ? <Close /> : <Menu />}
          </IconButton>
        </AppBar>
      ) : null}
      <AnimationWrapper animateIn={menuOpen} isMobile={isMobile}>
        <AppBar
          className={clsx(classes.navBar, { [classes.navBarMobile]: isMobile })}
          position="fixed"
        >
          {!isMobile ? (
            <>
              <LogoButton />
              <MenuDivider isMobile={isMobile} />
              <AppViewMenu loading={loading} />
              <MenuDivider isMobile={isMobile} />
            </>
          ) : null}
          <NavigationMenu
            activeMenu={activeMenu}
            isMobile={isMobile}
            onMenuOpen={setMenuOpen}
            operator={operator}
            setActiveMenu={setActiveMenu}
            user={user}
            loading={loading}
          />
          <UserPreferences
            isDarkMode={isDarkMode}
            isMobile={isMobile}
            setDarkMode={setIsDarkMode}
          />
        </AppBar>
      </AnimationWrapper>
      <Breadcrumbs />
    </>
  );
};

const useStyles = makeStyles((theme: any) => ({
  icon: {
    color: 'white',
    margin: 5,
    backgroundColor: 'transparent',
    '&:hover': {
      color: 'white',
      opacity: 0.8,
      backgroundColor: 'transparent',
    },
  },
  menuIcon: {
    position: 'absolute',
    right: 15,
  },
  mobileResort: {
    height: 70,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: theme.palette.paper.main,
    zIndex: 899,
  },
  navBar: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    color: 'white',
    backgroundColor: theme.palette.paper.main,
    height: 70,
    width: '100%',
    padding: 0,
    zIndex: 899,
  },
  navBarMobile: {
    top: 62,
    flexDirection: 'column',
    height: 'calc(100% - 62px)',
    width: '50%',
    zIndex: 898,
  },
}));
